export const works = [
    // Recent AI/ML Projects (Featured First)
    {
        id: "browsergpt",
        title: "BrowserGPT",
        description: "AI-powered assistant designed to streamline web interactions, automate tasks, and enhance user productivity through advanced natural language processing and seamless browser integration.",
        type: "icon",
        icon: "🤖",
        image: null,
        skills: ["AI Agents", "Prompt Engineering", "LLM", "MCP", "AI Engineer"],
        period: "Oct 2024 - Present",
        link: "https://browsergpt.co",
        featured: true,
        mobile: true
    },
    {
        id: "cursor-agent-tools",
        title: "Cursor Agent Tools",
        description: "A Python-based AI agent that replicates Cursor's coding assistant capabilities, enabling function calling, code generation, and intelligent coding assistance with Claude, OpenAI, and locally hosted Ollama models.",
        type: "icon",
        icon: "⚡",
        image: null,
        skills: ["GPT", "AI Agents", "Python", "LLM", "AI Engineer"],
        period: "Mar 2025 - Apr 2025",
        link: "https://github.com/civai-technologies/cursor-agent",
        featured: true,
        mobile: true
    },
    {
        id: "nova",
        title: "Nova",
        description: "An autonomous AI agent serving as a personal productivity assistant. Developed with advanced prompt engineering and software engineering, Nova offers sophisticated capabilities that surpass traditional virtual assistants like SIRI.",
        type: "icon",
        icon: "✨",
        image: null,
        skills: ["Software Engineering", "AI Agents", "Networking", "Prompt Engineering", "DevOps", "MCP", "Go"],
        period: "May 2023 - Apr 2024",
        link: "https://nova.civai.co",
        featured: true,
        mobile: true
    },
    {
        id: "medisix",
        title: "Medisix",
        description: "An AI-driven virtual health assistant providing 24/7 access to health information and symptom analysis.",
        type: "icon",
        icon: "🏥",
        image: null,
        skills: ["GPT", "AI Agents", "Prompt Engineering", "DevOps", "AI Engineer"],
        period: "Jul 2023 - Jul 2023",
        link: "https://medisix.civai.co",
        featured: true,
        mobile: true
    },
    {
        id: "zerolm",
        title: "ZeroLM",
        description: "Provides affordable access to leading LLMs like GPT-4 and Claude through a unique subscription model.",
        type: "icon",
        icon: "💡",
        image: null,
        skills: ["GPT", "AI Agents", "Networking", "Prompt Engineering", "DevOps", "AI Engineer"],
        period: "May 2023 - Jun 2023",
        link: "https://civai.co",
        featured: true,
        mobile: true
    },
    {
        id: "slidegen",
        title: "Slidegen",
        description: "Designed to simplify the creation of cohesive social media graphics by leveraging AI to generate brand-aligned visuals. This tool transforms simple prompts into high-quality graphics, making professional design accessible.",
        type: "icon",
        icon: "🎨",
        image: null,
        skills: ["AI Agents", "Prompt Engineering", "LLM", "DevOps", "Go", "Generative AI", "AI Engineer"],
        period: "Apr 2023 - May 2023",
        link: "https://slidegen.civai.co",
        featured: true,
        mobile: true
    },
    {
        id: "xspaces",
        title: "Xspaces",
        description: "Developed X-Spaces AI to facilitate real-time, interactive AI conversations for platforms like Twitter Spaces, Discord, and Podcasts. Using selective audio routing and LLMs, X-Spaces AI enables authentic AI-driven dialogues.",
        type: "icon",
        icon: "🎙️",
        image: null,
        skills: ["Software Engineering", "GPT-4", "Prompt Engineering", "LLM", "Generative AI", "AI Engineer"],
        period: "Mar 2023 - Apr 2023",
        link: "https://xspaces.civai.co",
        featured: true,
        mobile: true
    },
    {
        id: "civai-portfolio",
        title: "CIVAI Portfolio App",
        description: "Uses AI to optimize your crypto trades on Binance for higher returns, reduced risk, and instant withdrawals.",
        type: "icon",
        icon: "📈",
        image: null,
        skills: ["Software Engineering", "Networking", "Prompt Engineering", "DevOps", "AI"],
        period: "May 2022 - Jan 2023",
        link: "https://portfolio.civai.co",
        featured: true,
        mobile: true
    },

    // Legacy Projects (using same design as new ones)
    {
        id: "patricia",
        title: "Patricia",
        description: "Revolutionary fintech platform for cryptocurrency trading and digital payments in Nigeria.",
        type: "icon",
        icon: null,
        image: "/images/patricia.svg",
        skills: ["Fintech", "Cryptocurrency", "Payment Systems", "DevOps"],
        period: "2019 - 2021",
        link: "https://www.mypatricia.co/",
        featured: true,
        mobile: true
    },
    {
        id: "glover",
        title: "Glover",
        description: "A product for buying and selling gift cards, making bill payments, and other personalized services.",
        type: "icon",
        icon: null,
        image: "/images/glover.png",
        skills: ["E-commerce", "Payment Systems", "Gift Cards", "DevOps"],
        period: "Jan 2021 - Mar 2021",
        link: "https://www.gloverapp.co/",
        featured: true,
        mobile: true
    },
    {
        id: "roomxix",
        title: "RooomXIX",
        description: "Premium accommodation booking platform for short-term stays.",
        type: "icon",
        icon: null,
        image: "/images/roomxix.png",
        skills: ["E-commerce", "Booking Systems", "DevOps"],
        period: "2021",
        link: "https://www.rooomxix.com/",
        featured: true,
        mobile: true
    },
    {
        id: "doubleh",
        title: "The DoubleH",
        description: "Premium Short Stay Apartment Booking Platform.",
        type: "icon",
        icon: null,
        image: "/images/doublehlogo.png",
        skills: ["E-commerce", "Booking Systems", "DevOps"],
        period: "Jun 2021 - Aug 2021",
        link: "https://www.thedoubleh.co/",
        featured: true,
        mobile: true
    },
    {
        id: "hank",
        title: "Hank",
        description: "Hank helps you find any item with just the push of a button. No more missing keys, phones, or wallets. With Hank, you can do EVERYTHING.",
        type: "icon",
        icon: null,
        image: "/images/hank.svg",
        skills: ["IoT", "Mobile Apps", "DevOps"],
        period: "Jan 2021 - Jul 2021",
        link: "https://www.myhank.co/",
        featured: true,
        mobile: true
    }
];
